import React, { ReactElement } from "react";
import {
  PictureCard,
  PictureCardImage,
  PictureCardTitle,
  PictureCardProps,
  ImageRatio
} from "@silversea-ssc/ui-components-react";

import { ResponsiveSanityImage } from "@silversea-ssc/ui-components-react";
import { titleCase } from "src/utils/strings";
import { ResponsiveSanityImageProps } from ".yalc/@silversea-ssc/ui-components-react/dist/ResponsiveSanityImage/ResponsiveSanityImage";

export interface LinkPictureCardProps extends PictureCardProps {
  title: string | JSX.Element | undefined;
  imageAltText?: string;
  image?: ResponsiveSanityImageProps["image"];
  url?: string;
}

export function titleIsString(
  title: string | ReactElement | undefined
): title is string {
  return typeof title == "string";
}

const LinkPictureCard: React.FC<LinkPictureCardProps> = ({
  title,
  image,
  imageAltText,
  url,
  borderColor,
  trackingName
}) => {
  const titleCaseTitle = titleIsString(title) ? titleCase(title) : title;
  const altText = imageAltText || (titleIsString(title) ? title : undefined);
  const linkTitle = titleIsString(title) ? title : altText;

  return (
    <PictureCard borderColor={borderColor} trackingName={trackingName}>
      <a
        href={url}
        title={linkTitle}
        data-content-piece="card_button"
        style={{ display: "block" }}
      >
        {image && (
          <PictureCardImage>
            <ImageRatio ratio="card">
              <ResponsiveSanityImage
                image={image}
                alt={altText}
                draggable={false}
                loading="lazy"
                defaultWidth={400}
                defaultHeight={600}
              />
            </ImageRatio>
          </PictureCardImage>
        )}
        <PictureCardTitle>{titleCaseTitle}</PictureCardTitle>
      </a>
    </PictureCard>
  );
};

export default LinkPictureCard;
